<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <system-config-table />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import SystemConfigTable from './SystemConfigTable'

  export default {
    name: 'system-config',
    components: {SystemConfigTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/systemConfig/SystemConfig.vue